export async function getStaffPersonal({ employeeId, positionIds, actualOn }) {
  try {
    const positionIdsQuery =
      positionIds.length > 0
        ? positionIds
            .map((id) => `positionIds[]=${encodeURIComponent(id)}`)
            .join("&")
        : "positionIds[]=";

    const queryParams = [];
    if (employeeId)
      queryParams.push(`employeeId=${encodeURIComponent(employeeId)}`);
    queryParams.push(positionIdsQuery);
    if (actualOn) queryParams.push(`actualOn=${encodeURIComponent(actualOn)}`);

    const url = `/internal-api/employee/education/employee/level/courses?${queryParams.join(
      "&"
    )}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Ошибка: ", error);
    throw error;
  }
}
